/**
 * Aggregated object of process.env and window.__config__ to allow dynamic configuration
 */
const ENV = {
  ...Object.keys(process.env).reduce<Record<string, string>>((acc, key) => {
    const strippedKey = key.replace("REACT_APP_", "");
    acc[strippedKey] = process.env[key]!;
    return acc;
  }, {}),
  ...(window as any).__config__
};

/**
 * Helper to make sure that all envs are defined properly
 * @param name env variable name (without the REACT_APP prefix)
 * @param defaultValue Default variable name
 */
export function getEnv(name: string, defaultValue?: string): string {
  const value = ENV[name] || defaultValue;
  if (value !== undefined) {
    return value;
  }
  throw new Error(`Missing environment variable: ${name}`);
}

const Constants = {
  APP_NAME: "STPAmaster",
  SERVER_URL: getEnv("SERVER_URL", ""),
  CONTEXT_PATH: getEnv("CONTEXT_PATH", ""),
  // Max attachment size in MB
  MAX_ATTACHMENT_SIZE: Number(getEnv("MAX_ATTACHMENT_SIZE", "20")),
  ALLOWED_FILE_TYPES: [
    "image/jpeg",
    "image/png",
    "application/pdf",
    "application/zip",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.oasis.opendocument.text",
    "video/mp4",
    "audio/mpeg"
  ],

  DATE_FORMAT: "DD.MM.YYYY",
  DATE_DATA_FORMAT: "YYYY-MM-DD",
  TIME_DATA_FORMAT: "HH:mm:ss",

  HttpStatus: {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    CONFLICT: 409
  },

  MimeType: {
    JSON: "application/json",
    MULTIPART_FORM_DATA: "multipart/form-data",
    X_WWW_FORM_URLENCODED: "application/x-www-form-urlencoded;charset=UTF-8",
    PDF: "application/pdf"
  },

  // Axios uses lower case for header names
  Headers: {
    ACCEPT: "accept",
    AUTHORIZATION: "authorization",
    CONTENT_DISPOSITION: "content-disposition",
    CONTENT_TYPE: "content-type",
    IF_MODIFIED_SINCE: "if-modified-since",
    LAST_MODIFIED: "last-modified",
    LOCATION: "location"
  },

  AAII_FILE_NUMBER: `CZ-${new Date().getFullYear()}`,
  MESSAGE_DISPLAY_DURATION: 3000
};

export const SELECTED_LANGUAGE_KEY = "default-eccairs2-reporter-language";

export default Constants;
